// src/components/Navbar.js
import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [hasHero, setHasHero] = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 20);
    }

    function checkHasHero() {
      const hero =
        document.querySelector(".hero-section") ||
        document.querySelector("#home") ||
        document.querySelector(".carousel-inner");
      setHasHero(Boolean(hero));
    }

    checkHasHero();
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [location.pathname]);

  const navLinkClass = ({ isActive }) =>
    isActive ? "nav-link navlink-custom active" : "nav-link navlink-custom";

  // Use light or dark Bootstrap theme depending on scroll + hero presence
  const navThemeClass =
    scrolled || !hasHero
      ? "navbar navbar-expand-lg navbar-light container-fluid"
      : "navbar navbar-expand-lg navbar-dark container-fluid";

  const Logo = () => (
    <div className="d-flex align-items-center">
      <i className="bi bi-globe2 brand-icon me-2" aria-hidden />
      <span className="brand-text">SWSAA</span>
    </div>
  );

  return (
    <header
      className={`site-header ${scrolled || !hasHero ? "navbar-scrolled" : ""} ${location.pathname === "/" ? "home" : ""}`}
    >
      <nav className={navThemeClass}>
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
            <Logo />
          </Link>

          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
            aria-controls="mainNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              <li className="nav-item">
                <NavLink to="/" className={navLinkClass}>
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className={navLinkClass}>
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/services" className={navLinkClass}>
                  Services
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle navlink-custom"
                  href="#"
                  id="moreDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  More
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end shadow-lg"
                  aria-labelledby="moreDropdown"
                >
                  <li>
                    <NavLink to="/portfolio" className="dropdown-item">
                      Portfolio
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/pricing" className="dropdown-item">
                      Pricing
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact" className="dropdown-item">
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item ms-lg-3">
                <NavLink
                  to="/quote"
                  className={({ isActive }) =>
                    isActive
                      ? "btn btn-cta btn-cta-active rounded-pill px-3 py-2 fw-semibold"
                      : scrolled || !hasHero
                      ? "btn btn-cta-outline rounded-pill px-3 py-2 fw-semibold text-dark border-dark"
                      : "btn btn-cta-outline rounded-pill px-3 py-2 fw-semibold text-white border-white"
                  }
                >
                  <i
                    className="bi bi-send-fill me-1 d-none d-sm-inline-block"
                    aria-hidden
                  />
                  Get Quote
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
